// lib/filters/parseCntLinks

import component from './parseCntLink'

function parseCntLinks(text) {
  var pattern = /([A-Z]{4}[0-9]{7}(?![0-9]))/g
  if (!text) return text
  return text.replace(pattern, function(match) {
    return component.filters.parseCntLink(match)
  })
}

export default {filters: {parseCntLinks: parseCntLinks} }



/** WEBPACK FOOTER **
 ** ./src/js/lib/filters/parseCntLinks.js
 **/